/** @type {import('Simple/types.js').useDataOnSubmit} */
export default function useDataOnSubmit(props, data) {
  return async function onSubmit({ value, originalValue, change, args }) {
    switch (args?.type) {
      case 'add': {
        change(next => {
          next.push({})
        })
        break
      }

      case 'update_referral': {
        change(
          value.map((referral, index) => {
            if (index !== args.index) return referral

            return {
              ...args.referral,
              id: `${args.referral.id}-${args.index}`,
              template: args.referral,
              ...(args.referral.type === 'DropDown' && {
                selected_index: null,
              }),
              ...(args.referral.type === 'FreeText' && { text_value: '' }),
              ...(args.referral.type === 'Search' && { person: undefined }),
            }
          })
        )
        break
      }

      case 'update_person': {
        change(
          value.map((referral, index) => {
            if (index !== args.index) return referral

            return {
              ...referral,
              person: args.person,
            }
          })
        )
        break
      }

      case 'update_text_value': {
        change(
          value.map((referral, index) => {
            if (index !== args.index) return referral

            return {
              ...referral,
              text_value: args.text_value,
            }
          })
        )
        break
      }

      case 'update_selected_index': {
        change(
          value.map((referral, index) => {
            if (index !== args.index) return referral

            return {
              ...referral,
              selected_index: args.selected_index,
            }
          })
        )
        break
      }

      case 'clear_person': {
        change(
          value.map((referral, index) => {
            if (index !== args.index) return referral

            return {
              ...referral,
              person: undefined,
            }
          })
        )
        break
      }

      case 'remove': {
        change(value.filter((_, index) => index !== args.index))
        break
      }

      default: {
      }
    }
  }
}
